import React, {useRef} from 'react';
import styled from "styled-components";
import {PropTypes} from "prop-types";
import {useDispatch} from "react-redux";
import {setLanguage} from "redux-i18n";
import useOutsideClick from "../hooks/useOutsideClick";

const LanguageList = styled.div`
    color: ${props => props.theme.footerBackground || "rgba(12, 12, 12, 0.75)" };
    border-top: ${props => props.theme.footerBorderTop || "none" };
    background: ${props => props.theme.footerColor || "#ffffff" };
`;

const LanguageButton = styled.button`
    color: ${props => props.theme.footerBackground || "rgba(12, 12, 12, 0.75)" };
    width: 100%;
    cursor: pointer;
    padding: 0.5rem 0;
    
    &:hover {
        background-color: rgba(20, 20, 20, 0.01);
    }
    
`;

const LanguageButtonInner = styled.div`
    border-bottom: 1px solid ${props => props.theme.footerBackground || "rgba(12, 12, 12, 0.75)" };
    padding-bottom: 0.375rem;

    ${LanguageButton}:hover & {
        padding-bottom: 0.3125rem;
        border-bottom: 2px solid ${props => props.theme.footerBackground || "rgba(12, 12, 12, 0.75)" };
    }
    
`;

const LanguageSelectionList = ({hubLanguages, closeList, ignoreRef}) => {
    const dispatch = useDispatch();
    const languageListRef = useRef(null);
    useOutsideClick(languageListRef, closeList, ignoreRef);

    const onChangeLang = (lang) => {
        dispatch(setLanguage(lang));
        closeList();
    }

    return (
            <LanguageList ref={languageListRef}>
                <div className="grid-container">
                    <div>
                        <div className="grid-x justify-center grid-padding-x small-up-2 medium-up-3 large-up-4 py-2">
                            { hubLanguages.map((language) =>
                                <div
                                    key={language.code}
                                    className="cell my-1"
                                    onClick={() => onChangeLang(language.code)}
                                >
                                    <LanguageButton>
                                        <LanguageButtonInner>
                                            {language.name}
                                        </LanguageButtonInner>
                                    </LanguageButton>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </LanguageList>
    );
};

LanguageSelectionList.contextTypes = {
    t: PropTypes.func.isRequired
};

export default LanguageSelectionList;